import styles from "../Tabelas.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import { Table } from "../../../../components/Table";
import Button from "../../../../components/components-ui/Button/Button";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../../services/Api";
import Loading from "../../../../components/components-ui/Loading/Loading";

export default function PontosLocaisOrigem() {
  const [dados, setDados] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    async function getOrigens() {
      setShowLoading(true);
      const response = await api.get("/origem/index");
      setDados(response.data);
      setShowLoading(false);
    }
    getOrigens();
  }, []);
  // Colunas da tabela
  const columns = [
    {
      column: "Origem",
    },
  ];
  return (
    <Container>
      <h3>Listagem de Origem de Locais</h3>
      <Link
        to="/usina/pontoslocaisorigem/novo/"
        style={{ display: "contents" }}
      >
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {dados.map(({ id, origem }) => (
            <tr key={id}>
              <td>
                <Link to={`/usina/pontoslocaisorigem/edit/${id}`}>
                  <i className="fas fa-pencil-alt"></i>
                </Link>
              </td>
              <td>{origem}</td>
            </tr>
          ))}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? "block" : "none"} />
        </div>
      </div>
    </Container>
  );
}
